import { render, staticRenderFns } from "./moreProduct.vue?vue&type=template&id=5700da90&scoped=true&"
import script from "./moreProduct.vue?vue&type=script&lang=js&"
export * from "./moreProduct.vue?vue&type=script&lang=js&"
import style0 from "./moreProduct.vue?vue&type=style&index=0&id=5700da90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700da90",
  null
  
)

export default component.exports